import { type, string, exact } from 'io-ts';
import { HtmlStrip } from 'src/types/HtmlStrip';
import { WeatherLinksType } from 'src/types/WeatherLinksType';

export const WeatherDataType = exact(type({
    todayText: string,
    tabUrls: WeatherLinksType,

    morningTitle: string,
    todayMorningIcon: string,

    afternoonTitle: string,
    todayAfternoonIcon: string,

    eveningTitle: string,
    todayEveningIcon: string,

    todayMinTemp: string,
    todayMaxTemp: string,

    precipitationProbabilityShortTitle: string,
    precipitationProbabilityTitle: string,
    precipitationProbabilityToday: string,
    precipitationProbabilityTomorrow: string,
    precipitationTitle: string,
    precipitationTotal: string,

    sunriseAndSunsetTitle: string,

    sunriseTime: string,
    sunsetTime: string,

    sunshineTitle: string,
    sunshineTime: string,

    currentDate: string.pipe(HtmlStrip),
    producedDate: string.pipe(HtmlStrip),
    currentForecastTitle: string.pipe(HtmlStrip),
    weatherProviderTitle: string.pipe(HtmlStrip),
}));
